import { render, staticRenderFns } from "./InformationOutlineIcon.vue?vue&type=template&id=4878a4f3"
import script from "./InformationOutlineIcon.vue?vue&type=script&lang=js"
export * from "./InformationOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports